import React from 'react'
import { Card, Button, Avatar } from 'antd'
import { useDispatch } from 'react-redux'
import { removeAnnouncement } from '../../../reducers/announcementsReducer'

const { Meta } = Card

const AnnouncementCard = ({ announcement, user }) => {
  const dispatch = useDispatch()

  return (
    <div className="container">
      <Card
        hoverable
        className="custom-card"
        title={
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Meta
              avatar={<Avatar src={announcement.user.photo} />}
              title={announcement.user.name}
            />
            {announcement.user._id === user._id && (
              <Button
                disabled={!(announcement.user._id === user._id)}
                className="deleteButton"
                onClick={() => {
                  dispatch(removeAnnouncement(announcement._id))
                }}
              >
                Delete
              </Button>
            )}
          </div>
        }
      >
        <div className="annData">{announcement.data}</div>
      </Card>
    </div>
  )
}

export default AnnouncementCard
